module.exports = __webpack_public_path__ + "assets/img/yl_w_d_i_22.bbc6a2a8.jpg";